import { Box, Button, Grid, IconButton, InputAdornment, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { BtnBaseButton } from "components/Button/ButtonAll";
import LoginIcon from "@mui/icons-material/Login";
import LogoFossil from "assets/images/Logo/Logo.png";
import bgLogin from "assets/images/Logo/bg_Login_Fossil.jpg";
import bgLogin_0 from "assets/images/Logo/bg_Login_0.jpg";
import bgLogin_1 from "assets/images/Logo/bg_Login_1.jpg";
import bgLogin_2 from "assets/images/Logo/bg_Login_2.jpg";
import { FnAxios, FnDialog, I18n, OnElementFocus, ParseHtml, RouterDOM, SecureStorage } from "utilities/utilities";
import {TextBoxItem} from "components/Input/TextBox";
import { ApiApplyMember, ApiAuthentication } from "enum/api";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Close } from '@mui/icons-material';
import axios from 'axios';
import "./indexLogin.css";
import EmailOTP from "view/FrontEnd/ApplyMember/EmailOTP";
import DialogPreview from "components/DialogPreview/DialogPreview";
import { APIStatusCode, I18NextNs } from "enum/enum";
import { useNavigate } from "react-router";
import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { GetUserAccout } from "utilities/SystemFunction";
import ChangePassword from "components/Layout/components/ChangePassword";

const LoginCenter = (props) => {
    const AxiosFn = FnAxios();
    const Router = RouterDOM();
    const DialogFn = FnDialog();
    const navigate = useNavigate();

    const [isIconEye, setisIconEye] = useState(false);
    // const LayoutMin900 = useMediaQuery('(min-width:900px)');
    const LayoutMin980 = useMediaQuery('(min-width:980px)');
    const [sIPAddress, setsIPAddress] = useState<any>(null);
    
    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    const formOTP = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    useEffect(() => {
        setTimeout(() => {
            OnElementFocus("sUsername", "btnLogin");
            OnElementFocus("sPWD", "btnLogin");
        }, 2000);
        GetPublicIP();
    }, []);

    const GetPublicIP = async () => {
        let result = await axios.get("https://myexternalip.com/json");
        if (result?.data && result?.data.ip) {
            setsIPAddress(result.data.ip);
        } else {
            setsIPAddress(result.data);
        }
    };

    const connection = new HubConnectionBuilder()
    .withUrl(process.env.REACT_APP_API_URL + "hubs/auth")
    .withAutomaticReconnect()
    .build();

    const onLogin = () => {
        DialogFn.BlockUI();
        let oParam = {
            sUsername: form.getValues("sUsername"),
            sPWD: form.getValues("sPWD"),
            sIPAddress: sIPAddress,
        };
        AxiosFn.Post(ApiAuthentication.Login, oParam, (result) => {
            DialogFn.UnBlockUI();
            let objData = result.objResult;
            if (result.nStatusCode === APIStatusCode.Success)
            {
                if (result.objResult) {
                    SecureStorage.Set(process.env.REACT_APP_JWT_KEY, objData);
                    // Router.GoToPage("/Home");
                    // if(props.setisLogin) props.setisLogin(false);
                    // window.location.reload();

                    let objUser: IAvatar = GetUserAccout();
                    let sConnectionId = objUser.nUserID;
                    if (connection.state !== HubConnectionState.Connected) {
                        connection
                            .start()
                            .then(() => {
                                connection.send("OnSignOutSignal", sConnectionId ?? connection.connectionId, true)
                                Router.GoToPage("/Home");
                                if (props.setisLogin) props.setisLogin(false);
                                window.location.reload();
                            })
                    } 
                    else {
                        connection.send("OnSignOutSignal", sConnectionId ?? connection.connectionId, false)
                    }
                }
            }
            else if (result.nStatusCode === APIStatusCode.Confirm){
                DialogFn.Warning(result.sMessage, ()=> { 
                    form.setValue("sPWD", result.objResult?.sSecuredCode); 
                    setisChangePassword(true);  
                });
            }
            else {
                DialogFn.Warning(result.sMessage);
            }
        }, null, () => { DialogFn.UnBlockUI(); });
    };    
    
    //#region OTP
    const handleClickShowSecuredCode = () => setisIconEye((show) => !show);
    const handleMouseDownSecuredCode = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    };

    const [isDialogEmailOTP, setisDialogEmailOTP] = useState<any>(false);
    const [ObjEmailOTP, setObjEmailOTP] = useState<any>(null);
    const CallEmailOTP = useCallback(() => {
        return (
            <>
                { ObjEmailOTP && <EmailOTP setisOpen={()=>{ setObjEmailOTP(null); }} ObjEmailOTP={ObjEmailOTP} /> }
            </>
        );
    }, [ObjEmailOTP]);
    
    const handleEmailOTP = () => {
        DialogFn.BlockUI();
        let oParam = {
            sEmail: formOTP.getValues("txtEmail"),
        };
        AxiosFn.Post(ApiApplyMember.CheckEmailOTP, oParam, (result) => {  
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success) {   
                DialogFn.Success(I18n.SetText("msgOTP"), () => {
                    setisDialogEmailOTP(false);
                    setObjEmailOTP(result.objResult);        
                });
                DialogFn.CloseSubmit();
            } 
            else {               
                DialogFn.Warning(result.sMessage ?? I18n.SetText("msgErrorEmailOTP", I18NextNs.translation));
                setObjEmailOTP(null);        
            } 
        }, (err) => {
            DialogFn.UnBlockUI();
            if (!err.response) {
                DialogFn.Warning(err.sMessage);
            }
        });
    };
    //#endregion
    
    //#region Change Password
    const [isChangePassword, setisChangePassword] = useState(false);
    const CallChangePassword = useCallback(() => {
        return ((isChangePassword && <ChangePassword isOpen={isChangePassword} setisOpen={setisChangePassword} isChangePasswordLogin={false} sEmail={form.watch("sUsername")} sSecuredCode={form.watch("sPWD")} />));
    }, [isChangePassword]);
    //#endregion

    return (
        <Fragment>
            <Grid item container xs={12} md={12} className="bg" justifyContent={"center"} alignItems={"center"} alignContent={"center"} >
                {/* <Grid item xs={12} md={6} justifyContent={"center"} alignItems={"flex-end"} alignContent={"flex-end"} style={{ display: (LayoutMin900 ? '' : 'none')}} >
                    <img src={bgLogin} alt="Fossil Logo" className='img-background' />
                </Grid> */}
                <Grid item xs={12} md={6} justifyContent={"center"} alignItems={"flex-end"} alignContent={"flex-end"} style={{ display: (LayoutMin980 ? '' : 'none')}} >
                    <Box className="box-login">
                        <img src={bgLogin_0} alt="Fossil Logo" className='img-background' />
                        <Box className="box-text-login-H">
                            {ParseHtml("กองทุน <br/> จัดการซากดึกดำบรรพ์")}
                            <Box className="box-text-login-S">{ ParseHtml("เพื่อการบริหารจัดการซากดึกดำบรรพ์อย่างยั่งยืน")}</Box>
                        </Box>                        
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} spacing={2} justifyContent={"center"} alignItems={"flex-start"} alignContent={"flex-start"} className='div-gls-login'>
                    <Grid container justifyContent={"end"}>
                        <Tooltip title={I18n.SetText("close")} placement="right" arrow style={{ zIndex: 100000}}>
                            <div onClick={() => { if(props.setisLogin) props.setisLogin(false); }} >
                                <Close 
                                    fontSize='large' 
                                    className='m-[auto] text-[white]'
                                    style={{
                                        // backgroundColor: '#ff5151',
                                        // borderRadius: '20px',
                                        // color: '#790103',
                                        color: 'white',
                                        fontSize: '30px',
                                        cursor: 'pointer',
                                    }}    
                                />
                            </div>
                        </Tooltip>
                    </Grid>
                    <Grid item container spacing={2} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                        <FormProvider {...form}>
                            {/* <Grid item xs={10} sm={9}>
                                <Grid item container spacing={1} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                                    <Grid item container xs={12} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                                        <img src={LogoFossil} alt="Fossil Logo" className="image-fossil" />
                                    </Grid>
                                    <Grid item container xs={12} justifyContent={"center"} alignItems={"center"} alignContent={"center"} style={{ marginBottom: '4%',}}>
                                        <Typography color={'black'} variant="inherit" gutterBottom>กองทุนจัดการซากดึกดำบรรพ์</Typography>          
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '4%',}}>
                                        <Typography variant="overline" className="name-prj">ลงชื่อเข้าใช้งานระบบ</Typography>
                                        <Typography color={'black'} gutterBottom>ผู้ใช้งานกรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextBoxItem
                                            id={"sUsername"}
                                            name={"sUsername"}
                                            maxLength={150}
                                            // defaultValue="User"
                                            label={`${I18n.SetText("username")}`}
                                            required={true}
                                            type={"email"}
                                            onKeyPress={(e) => {
                                                if (e.keyCode === 13 || e.keyCode === 9) {
                                                    setTimeout(() => {
                                                        form.setError('sUsername', {type: 'required'}, {shouldFocus: true, });
                                                    }, 300);
                                                }
                                                else if (e.key === "Enter") {
                                                    let sSecuredCode = form.getValues("sPWD");
                                                    if (sSecuredCode) {
                                                        form.handleSubmit((e) => { onLogin(); });
                                                    } else {
                                                        form.setError('sPWD', {type: 'required'}, {shouldFocus: true, });
                                                    }                                                    
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextBoxItem
                                            id={"sPWD"}
                                            name={"sPWD"}
                                            maxLength={20}
                                            // defaultValue="P@ssw0rd"
                                            label={`${I18n.SetText("password")}`}
                                            required={true}
                                            type={isIconEye ? "text" : "password"}
                                            isPassword={true}
                                            isNotPatternPassword={true}
                                            endAdornment={ 
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowSecuredCode}
                                                        onMouseDown={handleMouseDownSecuredCode}
                                                        edge="end"
                                                    >
                                                    {isIconEye ? <VisibilityOffIcon style={{color:'#202178'}} /> : <VisibilityIcon style={{color:'#202178'}}/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") {
                                                    form.handleSubmit((e) => { onLogin(); });
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item container justifyContent={"flex-end"} alignItems={"flex-end"} alignContent={"flex-end"}>
                                        <Button variant="text" onClick={()=> { setisDialogEmailOTP(true);}}><Typography style={{color: '-webkit-link', cursor: 'pointer', textDecoration: 'underline', fontSize: '14px'}} gutterBottom>{I18n.SetText("forgotpassword")}</Typography></Button>
                                    </Grid>                                    
                                    <Grid item container spacing={4} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                                        <Grid item>
                                            <BtnBaseButton
                                                sx={{ width: "100%" }}
                                                startIcon={<LoginIcon />}
                                                txt={I18n.SetText("login")}
                                                id="btnLogin"
                                                className="btn-login"
                                                bgcolor="#169bd5"
                                                bgcolorHover="#098ec8"
                                                fontColor="#ffffff"
                                                IsCircleWithOutText ={false}
                                                isFullwidth={true}
                                                onClick={form.handleSubmit((e) => { onLogin(); })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                                            <Typography style={{fontSize: '14px', color: 'black' }} gutterBottom>{I18n.SetText("member")}</Typography>
                                            <Button variant="text" style={{ paddingBottom: '11px', paddingLeft: '1%', fontSize: '14px'}}><a onClick={()=> { navigate("/ApplyMember"); }} >{I18n.SetText("apply")}</a></Button>
                                        </Grid>
                                    </Grid>                                    
                                </Grid>
                            </Grid> */}
                            <Grid item xs={10} sm={9}>
                                <Grid item container spacing={1} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                                    {/* <Grid item container xs={12} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                                        <img src={LogoFossil} alt="Fossil Logo" className="image-fossil" />
                                    </Grid> */}
                                    <Grid item container xs={12} justifyContent={"center"} alignItems={"center"} alignContent={"center"} style={{ marginBottom: '5%',}}>
                                        <Typography color={'white'} variant="h6" gutterBottom>ลงชื่อเข้าใช้งานระบบ</Typography>          
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography color={'white'} variant="inherit" gutterBottom>{I18n.SetText("username")}</Typography>          
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '5%',}}>
                                        <TextBoxItem
                                            id={"sUsername"}
                                            name={"sUsername"}
                                            maxLength={150}
                                            // defaultValue="User"
                                            // label={`${I18n.SetText("username")}`}
                                            required={true}
                                            type={"email"}
                                            onKeyPress={(e) => {
                                                if (e.keyCode === 13 || e.keyCode === 9) {
                                                    setTimeout(() => {
                                                        form.setError('sUsername', {type: 'required'}, {shouldFocus: true, });
                                                    }, 300);
                                                }
                                                else if (e.key === "Enter") {
                                                    let sSecuredCode = form.getValues("sPWD");
                                                    if (sSecuredCode) {
                                                        form.handleSubmit((e) => { onLogin(); });
                                                    } else {
                                                        form.setError('sPWD', {type: 'required'}, {shouldFocus: true, });
                                                    }                                                    
                                                }
                                            }}
                                            sx={{
                                                "& .MuiOutlinedInput-root" : {
                                                    borderRadius: '20px !important',
                                                },
                                                "& .MuiOutlinedInput-input" : {
                                                    borderRadius: '20px !important',
                                                },                                                
                                            }}
                                            autoComplete="email"
                                            IsShowTextCont={false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography color={'white'} variant="inherit" gutterBottom>{I18n.SetText("password")}</Typography>          
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextBoxItem
                                            id={"sPWD"}
                                            name={"sPWD"}
                                            maxLength={20}
                                            // defaultValue="P@ssw0rd"
                                            // label={`${I18n.SetText("password")}`}
                                            required={true}
                                            type={isIconEye ? "text" : "password"}
                                            isPassword={true}
                                            isNotPatternPassword={true}
                                            endAdornment={ 
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowSecuredCode}
                                                        onMouseDown={handleMouseDownSecuredCode}
                                                        edge="end"
                                                    >
                                                    {isIconEye ? <VisibilityOffIcon style={{color:'#202178'}} /> : <VisibilityIcon style={{color:'#202178'}}/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") {
                                                    form.handleSubmit((e) => { onLogin(); });
                                                }
                                            }}
                                            sx={{
                                                "& .MuiOutlinedInput-root" : {
                                                    borderRadius: '20px !important',
                                                },
                                                "& .MuiOutlinedInput-input" : {
                                                    borderRadius: '20px !important',
                                                },                                       
                                            }}
                                            autoComplete="new-password"
                                            IsShowTextCont={false}
                                        />
                                    </Grid>
                                    <Grid item container xs={12} md={12} justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"center"} style={{ marginBottom: '2%',}}>
                                        <Grid item xs={6} md={6}>
                                            <Button variant="text" onClick={()=> { navigate("/ApplyMember"); }}><Typography style={{color: 'white', textDecoration: 'underline', cursor: 'pointer', fontSize: '16px'}} gutterBottom>{I18n.SetText("apply")}</Typography></Button>
                                        </Grid>   
                                        <Grid item xs={6} md={6} container justifyContent={"flex-end"} alignItems={"flex-end"} alignContent={"flex-end"}>
                                            <Button variant="text" onClick={()=> { setisDialogEmailOTP(true);}}><Typography style={{color: 'white', textDecoration: 'underline', cursor: 'pointer', fontSize: '16px'}} gutterBottom>{I18n.SetText("forgotpassword")}</Typography></Button>
                                        </Grid>    
                                    </Grid>                                
                                    <Grid item container spacing={4} justifyContent={"flex-end"} alignItems={"flex-end"} alignContent={"flex-end"}>
                                        <Grid item>
                                            <BtnBaseButton
                                                sx={{ width: "100%" }}
                                                txt={"LOGIN"}                                             
                                                id="btnLogin"
                                                className="btn-login"
                                                bgcolor="#169bd5"
                                                bgcolorHover="#098ec8"
                                                fontColor="#ffffff"
                                                IsCircleWithOutText ={false}
                                                isFullwidth={true}
                                                onClick={form.handleSubmit((e) => { onLogin(); })}
                                            />
                                        </Grid>
                                    </Grid>                                    
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Grid>
                </Grid>
            </Grid>
            <CallEmailOTP />                                      
            <DialogPreview
                IsOpen={isDialogEmailOTP}
                Title={I18n.SetText("ForgotPasswordOTP")}
                IsBackdropClick={false}
                onClose={() => { setisDialogEmailOTP(false); }}
                bgColor={"#a14828"}
                Color={"#ffffff"}
                JsxDialogAction
                sMaxWidth="xs"
                required={true}
                Close={false}
                CloseSave={true}        
                onClick={formOTP.handleSubmit((e) => handleEmailOTP())}        
            >
                <Grid item xs={12} md={12} container spacing={2} justifyContent={"center"} alignItems={"flex-start"} alignContent={"flex-start"}>
                    <FormProvider {...formOTP}>
                        <Grid item xs={12} md={11}>
                            <TextBoxItem
                                id={"txtEmail"}
                                name="txtEmail"
                                label={`${I18n.SetText("email")}`}  
                                maxLength={250}
                                required={true}
                                disabled={false}
                                type={'email'}
                            />
                        </Grid>
                    </FormProvider>   
                </Grid>
            </DialogPreview>    
            <CallChangePassword/> 
        </Fragment>
    );
}
export default LoginCenter;